<section class="editor-section container bg-white">
  <div class="newsticker-header-container">
    <div class="newsticker-title-container">
      <button class="back_icon me-2" (click)="goBack()">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <h1 class="newsticker-title">{{ title }}</h1>
    </div>
  </div>

  <form [formGroup]="form" (ngSubmit)="createNewticker()" class="editor-form">
    <quill-editor
      formControlName="sentence"
      [modules]="quillConfig"
      (onEditorCreated)="setQuillInstance($event)"
      (onSelectionChanged)="onSelectionChanged($event)"
      (onContentChanged)="onContentChanged($event)"
    >
    </quill-editor>

    <div class="button-group">
      <button
        mat-raised-button
        color="primary"
        class="submit-button"
        type="submit"
        [disabled]="form.invalid"
      >
        Submit
      </button>
    </div>
  </form>
</section>
